import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';

import { HeadlineH5 } from 'common/components/Typography';
import type { Color } from 'common/theme/colors/types';
import type { BannerProps } from '../../../types';
import { truncateStyles } from '../../utils/truncate';

type TitleProps = { title?: BannerProps['title']; textColor?: Color };

const InnerTitle = styled(HeadlineH5)`
  ${truncateStyles(2)};
`;

const innerTitleStyles: ComponentProps<typeof InnerTitle> = {
  as: 'h2',
  m: 'sp_0',
  color: 'sys.neutral.text.strong',
};

const Title = ({ title, textColor }: TitleProps) => {
  if (!title) return null;

  return (
    <InnerTitle {...innerTitleStyles} color={textColor}>
      {title}
    </InnerTitle>
  );
};

export default Title;
